import React from "react"
import {hasAuth} from "../auth"
import css from "../css"

if (css) require('./edit-copy.scss')

const auth = hasAuth(['admin', 'copy'])

export const EditCopy = React.createClass({

    render() {
        const rich = this.props.rich || true
        const textarea = this.props.textarea || true
        const top = this.props.top || 0
        const right = this.props.right || 0
        const href = `/cms/site/content/${this.props.name}?textarea=${textarea}&rich=${rich}&chrome=false`
        return auth
            ? <a
                className="edit-copy"
                href="#"
                style={{position:'absolute', top: top+'px', right: right+'px'}}
                onClick={e => {
                    e.preventDefault();
                    window.open(href, "Edit Content", 'width=800,height=600')
                }}>
                <button>Edit</button>
            </a>
            : null
    }
})



// WEBPACK FOOTER //
// ./src/components/edit-copy.jsx